import React from 'react';
import Heading from '../heading/heading';
import Home from './home.js';
import About from '../about/about.js';
import Footer from '../footer/footer';
import GetDirection from '../get-direction/getdirection';
import RecentImages from '../home-recent/recent';


function Homepage () {


    return (
        <div className="fullhome_page">
  <Heading />     
    <Home />
     <About /> 
     <RecentImages />
      <GetDirection />
      <Footer />
        </div>
    )


}

export default Homepage;